import React, { useState, useEffect } from 'react';
import { clappingHands } from '../../assets/emojis'
import { trustpilot, trustpilot_five_stars } from '../../assets/logos'

import { Emoji, Avatar, Card, Separator, Slider } from 'hosman-material'

import TRUSTPILOT_REVIEWS from '../../apiPublic/ressources/trustpilotReviews'

const TrustpilotReviews = ({
  expertId,
  limit=6,
  title=(<a href='https://fr-be.trustpilot.com/review/www.hosman.co' className='text-center mx-auto'>
          <p className='h2'>
            Ils ont vendu avec <span className='text-ih-blue'>Hosman</span>
          </p>

          <div className='flex justify-center items-center gap-2 font-medium'>
            4,8/5 Excellent <img src={trustpilot} alt='trustpilot' className='w-28 h-7'/>
          </div>
        </a>)
}) => {
  const [reviews, setReviews] = useState([])

  useEffect(() => {
    if (!expertId) return;

    TRUSTPILOT_REVIEWS.getExpertReviews(expertId, { limit: limit }).then((response) => {
      setReviews(response.data)
    });
  }, []);

  if (reviews.length < 1) return null;

  return(
    <div className='flex flex-col gap-6 bg-hosman-gradient-1 p-10'>
      {title}

      <Slider
        items={reviews.map(({ id, user_full_name, user_review_title, user_review_content, expert_name }) => (
          <Card key={id} classes='w-[270px]'>
            <div className='flex flex-col gap-4 p-5'>
              <div className='flex gap-3'>
                <Avatar bgColor='bg-ih-purple-10' textColor='text-ih-indigo' userName={user_full_name} />

                <div className='flex flex-col gap-1'>
                  <p className='h4 text-ih-indigo'>{user_full_name.split(' ')[0]}</p>

                  <p className='text-ih-purple-50 text-sm'>Vendu par {expert_name}</p>
                </div>
              </div>

              <Separator margins='my-2' borderColor='border-ih-purple-10' />

              <div className='flex flex-col gap-3 text-sm'>
                <img src={trustpilot_five_stars} alt='trustpilot_five_stars' className='w-36 h-7' />

                <div className='flex flex-col gap-3 max-h-[200px] overflow-scroll scrollbar-hide'>
                  <p className='font-semibold'>{user_review_title}</p>
                  <p className='whitespace-pre-line'>{user_review_content}</p>
                </div>
              </div>
            </div>
          </Card>
        ))}
      />
    </div>
  )
};

export default TrustpilotReviews;
